import { GuidePriority } from "../guide";
import type { GuideContext, GuideStep, HubFacts } from "../guide";

/**
 * Captain Bram on Gold Research (M35, docs/RESEARCH.md): the first time a research node is affordable, a line on the
 * lobby pointing at Towers, then — in a tower's upgrade sheet — one on its Research row. Each once per save, target
 * required (a hub without the Towers tab or a sheet without the row simply never shows it).
 */

export const ResearchTargets = {
  towersTab: ".tab[data-tab=towers]",
  researchRow: ".sheet.upgrade [data-guide=research]",
} as const;

/** Hub feature tips wait for the first session (scripts/features.ts HubTipsFromCleared). */
const TipsFromCleared = 2;

const hubAfterFirstSession = (c: GuideContext): HubFacts | null => (c.screen === "hub" && c.hub !== null && c.hub.highestCleared >= TipsFromCleared ? c.hub : null);
const affordable = (h: HubFacts | null): boolean => (h?.extras.research?.affordable ?? 0) > 0;

const TIP = { kind: "tip", block: "none", needsTarget: true } as const;

export const researchHubSteps: readonly GuideStep[] = [
  { ...TIP, id: "hub.research", screen: "hub", pose: "pointing", priority: GuidePriority.NewThing, topic: "research",
    target: { dom: ResearchTargets.towersTab }, unless: ["hub.researchRow"],
    text: "Gold can buy **Research** now: permanent perks for a tower. Open **Towers** and pick one!",
    when: (c) => { const h = hubAfterFirstSession(c); return h !== null && h.sheet === null && affordable(h); } },
  { ...TIP, id: "hub.researchRow", screen: "hub", pose: "pointing", priority: GuidePriority.NewThing, topic: "research",
    target: { dom: ResearchTargets.researchRow },
    text: "**Research** gives this tower perks for good: more damage, range and points. Tap to see its tree!",
    when: (c) => { const h = hubAfterFirstSession(c); return h !== null && h.sheet === "upgrade" && affordable(h); } },
];
